// removed by extract-text-webpack-plugin
module.exports = {"col":"src-components-Col----Col-module---col---2SqTI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Col/Col.module.scss
// module id = 265
// module chunks = 221374088121123